<template>
    <card plain class="m-0">
        <div class="mb-1">
            <strong>{{ state.name }} ({{ state.abbreviation }})</strong>
        </div>
        <b-check :checked="value?.ship"
            @change="handleAllowedState($event)">
            Allow Shipping
        </b-check>
        <b-check :checked="value?.pdmp"
            @change="handlePdmpReportingState($event)">
            PDMP Reporting
        </b-check>
        <b-form-group label="License Number">
            <b-input size="sm"
                :value="value?.license"
                @input="handleLicenseState($event)" />
        </b-form-group>
    </card>
</template>

<script lang="ts">
import { Component, Vue, Prop } from "vue-property-decorator";
import { ValidValues } from '@/data/ValidValues';
import { StoreStateOption } from "@/models/Store";

@Component({
    name: "StoreStateOptionItem"
})
export default class StoreStateOptionItem extends Vue {
    @Prop({ required: true }) protected state!: ValidValues.State;
    @Prop({ default: null }) protected value!: StoreStateOption | null;

    handleAllowedState(ship: boolean) {
        this.$emit("change", { ...this.value, state: this.state.abbreviation, ship });
    }

    handlePdmpReportingState(pdmp: boolean) {
        this.$emit("change", { ...this.value, state: this.state.abbreviation, pdmp });
    }

    handleLicenseState(license: string) {
        this.$emit("change", { ...this.value, state: this.state.abbreviation, license });
    }
}
</script>